import { useNavigate } from "react-router-dom";

export default function Confidentialite() {
  const navigate = useNavigate();

  const goBack = () => {
    navigate("/");
  };

  return (
    <div className="min-h-screen text-white relative">
      {/* Fixed global background */}
      <div className="fixed inset-0 -z-50">
        <img
          src="https://readdy.ai/api/search-image?query=Abstract%20luxury%20dark%20digital%20background%20dominated%20by%20deep%20black%20and%20rich%20dusty%20rose%20pink%20tones%2C%20soft%20blush%20pink%20glowing%20light%20orbs%20and%20delicate%20pink%20neon%20geometric%20curves%20floating%20in%20dark%20space%2C%20elegant%20web%20design%20wireframes%20and%20typography%20compositions%20in%20subtle%20rose%20pink%20hues%2C%20smooth%20pink%20gradient%20light%20rays%20emanating%20from%20corners%2C%20no%20yellow%2C%20no%20orange%2C%20no%20warm%20gold%20tones%2C%20only%20cool%20rose%20pink%20and%20black%2C%20sophisticated%20feminine%20digital%20art%20studio%20aesthetic%2C%20no%20people%2C%20no%20faces%2C%20cinematic%20depth%20with%20soft%20pink%20bokeh%2C%208K%20ultra%20detailed%20professional%20digital%20art&width=1920&height=1080&seq=manovahero5rose&orientation=landscape"
          alt=""
          className="w-full h-full object-cover object-[65%_center] md:object-center"
        />
        <div className="absolute inset-0 bg-black/50" />
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-transparent to-black/60" />
      </div>

      <div className="relative z-10 max-w-3xl mx-auto px-6 md:px-10 py-32 md:py-40">
        <button
          onClick={goBack}
          className="flex items-center gap-2 text-sm text-white/50 hover:text-brand transition-colors mb-12"
        >
          <i className="ri-arrow-left-line"></i>
          Retour au site
        </button>

        <h1 className="text-3xl md:text-4xl font-display font-medium text-white mb-10">
          Politique de confidentialité
        </h1>

        <div className="space-y-10 text-white/70 text-base leading-relaxed font-light">
          <section>
            <h2 className="text-lg font-display font-medium text-white mb-3">
              Introduction
            </h2>
            <p>
              La présente politique de confidentialité décrit comment Manova Digital collecte, utilise et protège les informations personnelles que vous nous fournissez via notre site web. En utilisant ce site, vous acceptez les pratiques décrites dans cette politique.
            </p>
          </section>

          <section>
            <h2 className="text-lg font-display font-medium text-white mb-3">
              Données collectées
            </h2>
            <p>
              Nous collectons uniquement les informations nécessaires au traitement de vos demandes : nom, adresse e-mail, et tout autre élément que vous choisissez de nous communiquer via le formulaire de contact. Nous ne collectons pas de données à des fins publicitaires ni de traçage comportemental.
            </p>
          </section>

          <section>
            <h2 className="text-lg font-display font-medium text-white mb-3">
              Utilisation des données
            </h2>
            <p>
              Les informations collectées sont utilisées uniquement pour :
            </p>
            <ul className="list-disc list-inside mt-2 space-y-1">
              <li>Répondre à vos demandes de contact</li>
              <li>Vous fournir les services demandés</li>
              <li>Vous tenir informé de l'avancement de votre projet (si applicable)</li>
            </ul>
          </section>

          <section>
            <h2 className="text-lg font-display font-medium text-white mb-3">
              Conservation des données
            </h2>
            <p>
              Vos données personnelles sont conservées uniquement le temps nécessaire au traitement de votre demande. Elles ne sont ni vendues, ni partagées avec des tiers à des fins commerciales.
            </p>
          </section>

          <section>
            <h2 className="text-lg font-display font-medium text-white mb-3">
              Vos droits
            </h2>
            <p>
              Conformément à la loi suisse sur la protection des données, vous disposez d'un droit d'accès, de rectification et de suppression de vos données personnelles. Pour exercer ces droits, contactez-nous à l'adresse : contact@manova-digital.ch.
            </p>
          </section>

          <section>
            <h2 className="text-lg font-display font-medium text-white mb-3">
              Cookies
            </h2>
            <p>
              Notre site utilise uniquement des cookies techniques nécessaires à son bon fonctionnement. Nous n'utilisons pas de cookies de traçage ou de profilage à des fins publicitaires. La bannière de cookies vous permet de gérer vos préférences.
            </p>
          </section>

          <section>
            <h2 className="text-lg font-display font-medium text-white mb-3">
              Modifications
            </h2>
            <p>
              Nous nous réservons le droit de modifier cette politique de confidentialité à tout moment. Toute modification sera publiée sur cette page avec une date de mise à jour.
            </p>
          </section>
        </div>
      </div>
    </div>
  );
}